export const CURVES = 'Curves';
export const CURVE_DETAILS = 'Curve details';
export const MARKET_DATA_REPORT = 'Market data lookback report';
export const PAGE_TITLE_PREFIX = 'AT';
export const PRICING = 'Pricing';
export const ASSET_MASTER = 'Asset master';
export const ASSET_DETAILS = 'Asset details';
export const VALUATION_RUNS = 'Valuation runs';
export const VALUATION_RUN_DETAILS = 'Valuation run details';
export const PORTFOLIO_SETUP = 'Portfolio setup';
export const INDEXES = 'Indexes';
export const CLASSIFICATION_RUN_DETAILS = 'Classification run details';
export const PORTFOLIOS = 'Portfolios';
export const SPLIT_FLAGS = 'Split flags';
export const ENTITIES = 'Entities';
export const ENTITY_MASTER = 'Entity master';
export const ENTITY_MASTER_DETAILS = 'Entity master details';
export const RISK_RUNS = 'Risk runs';
export const RISK_DETAILS = 'Risk run details';
export const VALUATION_RANGE_RUNS = 'Valuation range runs';
export const DATA_IMPORT_PIPELINES = 'Pipelines';
export const DATA_IMPORT_PIPELINE_EDIT = 'Pipeline edit';
export const DATA_IMPORT_RUNS = 'Runs';
export const DATA_IMPORT_RUN_EDIT = 'Run edit';
export const DATA_IMPORT_VARIABLE_SETS = 'Variable sets';
export const DATA_IMPORT_TASK_TYPES = 'Task types';
